import {Component, OnInit} from '@angular/core';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {CommandService} from '@core/services/command.service';
import {AddDriveDialogComponent} from '../add-drive-dialog/add-drive-dialog.component';
import {AddMemberToItemCommand, CreateDriveCommand, DeleteDriveCommand, RenameDriveCommand} from '../../commands/create-directory.command';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MemberDialogModel, ShareItemService} from '@shared/services/share-item.service';
import {DialogService} from '@shared/services/dialog-service';
import {FileManagerService} from '../../services/file-manager.service';
import {take} from 'rxjs/operators';
import {GridValueChangeEvent} from '@shared/models/common.models';

@Component({
    standalone: false,
    selector: 'particle-shared-drives',
  templateUrl: './shared-drives.component.html',
  styleUrls: ['./shared-drives.component.scss']
})
export class SharedDrivesComponent implements OnInit {
  sourceKey: string;
  breadcrumbs: BreadcrumbModel[];
  public ngUnsubscribe = new Subject<void>();
  invalidateSubject: InvalidateSubject;
  canAddDrive: boolean;
  defualtBoardPermisssion = {
    'title': 'No Access',
    'description': 'Cannot access any ticket(s)',
    'permissionType': 0
  };

  constructor(protected router: Router,
              protected dialog: MatDialog,
              protected commandService: CommandService,
              protected shareItemService: ShareItemService,
              protected dialogService: DialogService,
              private fileManagerService: FileManagerService
  ) {
    this.sourceKey = 'SharedDrives';
    this.canAddDrive = true;
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Repository',
        title: 'Repository',
        relativeUrl: 'repository',
        type: 'Repository'
      },
      <BreadcrumbModel>{
        id: 'TeamDrives',
        title: 'Team Drives',
        relativeUrl: 'team-drives'
      }
    ];
    this.invalidateSubject = new InvalidateSubject();
  }

  ngOnInit() {
  }

  onGridCellValueChange($event: GridValueChangeEvent) {
    if ($event.item.cells) {
      if ($event.item.cells['Type']) {
        switch ($event.item.cells['Type'].value) {
          case 'SharedDrives':
            this.router.navigateByUrl('team-drives');
            break;
          case 'SharedDrive':
            this.router.navigateByUrl(`drive/${$event.item.id}`);
            break;
          case 'PersonalDrive':
            this.router.navigateByUrl(`drive/${$event.item.id}`);
            break;
          case 'SharedWithMe':
            this.router.navigateByUrl(`shared-with-me`);
            break;
        }
      } else {
        if (!$event.item.cells['DriveId'] || !$event.item.cells['DriveId'].value) {
          console.error('Drive ID not found');
        } else {
          this.router.navigateByUrl(`drive/${$event.item.cells['DriveId'].value}/${$event.item.id}`);
        }
      }
    } else if ($event.action) {
      switch ($event.action.id) {
        case 'ManageMembers':
          this.openManageMembersDialog($event);
          break;
        case 'Rename':
          this.renameDrive($event);
          break;
        case 'Delete':
          this.deleteDrive($event);
      }
    }
  }

  renameDrive($event) {
    const dialogRef = this.dialog.open(AddDriveDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      disableClose: true,
      data: {
        name: $event.item.cells.Name.value
      }
    });
    dialogRef.afterClosed().pipe().subscribe((result: string) => {
      if (result) {
        this.commandService.executeCommand(new RenameDriveCommand($event.item.id, result)).pipe().subscribe(data => {
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

  openManageMembersDialog($event) {
    const model = new MemberDialogModel();
    model.invalidateSubject = this.invalidateSubject;
    model.configKey = 'DriveMembersKey';
    model.itemId = $event.item.id;
    model.metaData = {
      'DriveName': $event.item.cells.Name.value
    };
    this.fileManagerService.getSharedMembersByDriveId($event.item.id).pipe(take(2)).subscribe(item => {
      if (item) {
        const selectedUsers = this.shareItemService.mapSelectedUsers(item.userGroups);
        const contactsMetaData = {
          'selectedUsers': selectedUsers,
          'permissions': item.permissions,
          'defaultPermission': this.defualtBoardPermisssion
        };
        const command = new AddMemberToItemCommand('', $event.item.id, [], model.metaData);
        this.shareItemService.showDialog(model, contactsMetaData, command);
      }
    });
  }

  addDrive() {
    const dialogRef = this.dialog.open(AddDriveDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      disableClose: true
    });
    dialogRef.afterClosed().pipe().subscribe((result: string) => {
      if (result) {
        this.commandService.executeCommand(new CreateDriveCommand(result)).pipe().subscribe(data => {
          this.router.navigateByUrl(`drive/${data.Payload.Id}`);
        });
      }
    });
  }

  private deleteDrive($event: any) {
    const message = ($event.item.cells.MemberCount.value) > 1
      ? `The drive ${$event.item.cells.Name.value} has been shared with ${$event.item.cells.MemberCount.displayText}. Are you sure you want to delete?`
      : 'Are you sure you want to delete?';
    this.dialogService.showYesNoDialog('Confirm Delete', message).pipe().subscribe(state => {
      if (state && state.action === 'OK') {
        console.log('Received', state);
        const command = new DeleteDriveCommand($event.item.id);
        this.commandService.executeCommand(command).pipe().subscribe(data => {
          this.invalidateSubject.invalidate();
        });
      }
    });
  }

}
